<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="toc">
<a id="page10"></a>
<a id="page11"></a>
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry" id="pt_01">
<p class="contentsEntryNumber"><a href="#/xhtml/part01#pt01">Blueberry Notebook</a></p></div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryName"><a href="#/xhtml/chapter01#ch01">Ode to Inspiration</a></p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryName"><a href="#/xhtml/chapter02#ch02">Form</a></p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryName"><a href="#/xhtml/chapter03#ch03">January 8 (Blueberries)</a></p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryName"><a href="#/xhtml/chapter04#ch04">Ode to the Plantar Fascia</a></p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryName"><a href="#/xhtml/chapter05#ch05">January 17 (Krome Avenue)</a></p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryName"><span href="#/xhtml/chapter06#ch06" title="Link target outside of Sample">Ode to a Can of Schaefer Beer</span></p></div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryName"><span href="#/xhtml/chapter07#ch07" title="Link target outside of Sample">Ode to Bureaucrats</span></p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryName"><span href="#/xhtml/chapter08#ch08" title="Link target outside of Sample">January 22 (Specimens)</span></p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryName"><span href="#/xhtml/chapter09#ch09" title="Link target outside of Sample">Bash<span class="omacr">o</span></span></p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryName"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">February 3 (Workshop)</span></p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryName"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Ode to Blueberries</span></p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryName"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">February 16 (Paradise)</span></p></div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryName"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Lincoln Road</span></p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryName"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Neruda</span></p></div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryName"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Dahlias</span></p></div>
<a id="page12"></a>
<div class="contentsEntry" id="pt_02">
<p class="contentsEntryNumber"><span href="#/xhtml/part02#pt02" title="Link target outside of Sample">Civilization Notebook</span></p></div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryName"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Time</span></p></div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryName"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">March 10 (Barbarians)</span></p></div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryName"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Now</span></p></div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryName"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">The Past</span></p></div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryName"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">March 15 (History)</span></p></div>
<div class="contentsEntry" id="ch_21">
<p class="contentsEntryName"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">March 18 (Origins)</span></p></div>
<div class="contentsEntry" id="ch_22">
<p class="contentsEntryName"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Phoenix</span></p></div>
<div class="contentsEntry" id="ch_23">
<p class="contentsEntryName"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Egyptology</span></p></div>
<div class="contentsEntry" id="pt_03">
<p class="contentsEntryNumber"><span href="#/xhtml/part03#pt03" title="Link target outside of Sample">Papyrus Notebook</span></p></div>
<div class="contentsEntry" id="ch_24">
<p class="contentsEntryName"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">March 29 (Early Spring)</span></p></div>
<div class="contentsEntry" id="ch_25">
<p class="contentsEntryName"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Rilke</span></p></div>
<div class="contentsEntry" id="ch_26">
<p class="contentsEntryName"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">April 4 (Ideas)</span></p></div>
<div class="contentsEntry" id="ch_27">
<p class="contentsEntryName"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">Existence</span></p></div>
<div class="contentsEntry" id="ch_28">
<p class="contentsEntryName"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">Consciousness</span></p></div>
<div class="contentsEntry" id="ch_29">
<p class="contentsEntryName"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">Rilke and God</span></p></div>
<div class="contentsEntry" id="ch_30">
<p class="contentsEntryName"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample">3 a.m</span></p></div>
<div class="contentsEntry" id="ch_31">
<p class="contentsEntryName"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample">April 13 (Lilies)</span></p></div>
<div class="contentsEntry" id="ch_32">
<p class="contentsEntryName"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample">April 20 (Texts)</span></p></div>
<div class="contentsEntry" id="ch_33">
<p class="contentsEntryName"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample">Dim Sum</span></p></div>
<div class="contentsEntry" id="ch_34">
<p class="contentsEntryName"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample">Sleep</span></p></div>
<div class="contentsEntry" id="ch_35">
<p class="contentsEntryName"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample">April 26 (Meanwhile)</span></p></div>
<a id="page13"></a>
<div class="contentsEntry" id="ch_36">
<p class="contentsEntryName"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample">Invitations</span></p></div>
<div class="contentsEntry" id="ch_37">
<p class="contentsEntryName"><span href="#/xhtml/chapter37#ch37" title="Link target outside of Sample">Papyrus</span></p></div>
<div class="contentsEntry" id="ch_38">
<p class="contentsEntryName"><span href="#/xhtml/chapter38#ch38" title="Link target outside of Sample">May 12 (Rhetoric)</span></p></div>
<div class="contentsEntry" id="ch_39">
<p class="contentsEntryName"><span href="#/xhtml/chapter39#ch39" title="Link target outside of Sample">Homage to Syntax</span></p></div>
<div class="contentsEntry" id="ch_40">
<p class="contentsEntryName"><span href="#/xhtml/chapter40#ch40" title="Link target outside of Sample">Forms of Attention</span></p></div>
<div class="contentsEntry" id="ch_41">
<p class="contentsEntryName"><span href="#/xhtml/chapter41#ch41" title="Link target outside of Sample">May 23 (Dreams)</span></p></div>
<div class="contentsEntry" id="ch_42">
<p class="contentsEntryName"><span href="#/xhtml/chapter42#ch42" title="Link target outside of Sample">June 1 (Civilization)</span></p></div>
<div class="contentsEntry" id="ch_43">
<p class="contentsEntryName"><span href="#/xhtml/chapter43#ch43" title="Link target outside of Sample">Late Spring</span></p></div>
<div class="contentsEntry" id="pt_04">
<p class="contentsEntryNumber"><span href="#/xhtml/part04#pt04" title="Link target outside of Sample">Dawn Notebook</span></p></div>
<div class="contentsEntry" id="ch_44">
<p class="contentsEntryName"><span href="#/xhtml/chapter44#ch44" title="Link target outside of Sample">Dawn</span></p></div>
<div class="contentsEntry" id="ch_45">
<p class="contentsEntryName"><span href="#/xhtml/chapter45#ch45" title="Link target outside of Sample">June 28 (Dawn)</span></p></div>
<div class="contentsEntry" id="ch_46">
<p class="contentsEntryName"><span href="#/xhtml/chapter46#ch46" title="Link target outside of Sample">Early July</span></p></div>
<div class="contentsEntry" id="ch_47">
<p class="contentsEntryName"><span href="#/xhtml/chapter47#ch47" title="Link target outside of Sample">The Beach</span></p></div>
<div class="contentsEntry" id="ch_48">
<p class="contentsEntryName"><span href="#/xhtml/chapter48#ch48" title="Link target outside of Sample">July 3 (Rays)</span></p></div>
<div class="contentsEntry" id="ch_49">
<p class="contentsEntryName"><span href="#/xhtml/chapter49#ch49" title="Link target outside of Sample">July 9 (Dawn)</span></p></div>
<div class="contentsEntry" id="ch_50">
<p class="contentsEntryName"><span href="#/xhtml/chapter50#ch50" title="Link target outside of Sample">Reading Walt Whitman at Dawn</span></p></div>
<div class="contentsEntry" id="ch_51">
<p class="contentsEntryName"><span href="#/xhtml/chapter51#ch51" title="Link target outside of Sample">Beauty</span></p></div>
<div class="contentsEntry" id="ch_52">
<p class="contentsEntryName"><span href="#/xhtml/chapter52#ch52" title="Link target outside of Sample">July 14 (Surfing)</span></p></div>
<div class="contentsEntry" id="ch_53">
<p class="contentsEntryName"><span href="#/xhtml/chapter53#ch53" title="Link target outside of Sample">Questions</span></p></div>
<div class="contentsEntry" id="ch_54">
<p class="contentsEntryName"><span href="#/xhtml/chapter54#ch54" title="Link target outside of Sample">The Beach</span></p></div>
<div class="contentsEntry" id="ch_55">
<p class="contentsEntryName"><span href="#/xhtml/chapter55#ch55" title="Link target outside of Sample">Zodiac Narrative</span></p></div>
<div class="contentsEntry" id="ch_56">
<p class="contentsEntryName"><span href="#/xhtml/chapter56#ch56" title="Link target outside of Sample">Days of Late July</span></p></div>
<a id="page14"></a>
<div class="contentsEntry" id="ch_57">
<p class="contentsEntryName"><span href="#/xhtml/chapter57#ch57" title="Link target outside of Sample">Late July, After Three Days of Rain</span></p></div>
<div class="contentsEntry" id="ch_58">
<p class="contentsEntryName"><span href="#/xhtml/chapter58#ch58" title="Link target outside of Sample">July 31 (Issa)</span></p></div>
<div class="contentsEntry" id="ch_59">
<p class="contentsEntryName"><span href="#/xhtml/chapter59#ch59" title="Link target outside of Sample">Night Thoughts</span></p></div>
<div class="contentsEntry" id="ch_60">
<p class="contentsEntryName"><span href="#/xhtml/chapter60#ch60" title="Link target outside of Sample">August</span></p></div>
<div class="contentsEntry" id="ch_61">
<p class="contentsEntryName"><span href="#/xhtml/chapter61#ch61" title="Link target outside of Sample">August 5 (Tristesse)</span></p></div>
<div class="contentsEntry" id="ch_62">
<p class="contentsEntryName"><span href="#/xhtml/chapter62#ch62" title="Link target outside of Sample">Philadelphia</span></p></div>
<div class="contentsEntry" id="ch_63">
<p class="contentsEntryName"><span href="#/xhtml/chapter63#ch63" title="Link target outside of Sample">August 8 (Half-Day Blues)</span></p></div>
<div class="contentsEntry" id="ch_64">
<p class="contentsEntryName"><span href="#/xhtml/chapter64#ch64" title="Link target outside of Sample">Consolation</span></p></div>
<div class="contentsEntry" id="ch_65">
<p class="contentsEntryName"><span href="#/xhtml/chapter65#ch65" title="Link target outside of Sample">Mid-August</span></p></div>
<div class="contentsEntry" id="ch_66">
<p class="contentsEntryName"><span href="#/xhtml/chapter66#ch66" title="Link target outside of Sample">August 16 (Haiku)</span></p></div>
<div class="contentsEntry" id="ch_67">
<p class="contentsEntryName"><span href="#/xhtml/chapter67#ch67" title="Link target outside of Sample">August 21 (Coquinas)</span></p></div>
<div class="contentsEntry" id="ch_68">
<p class="contentsEntryName"><span href="#/xhtml/chapter68#ch68" title="Link target outside of Sample">Surfers</span></p></div>
<div class="contentsEntry" id="ch_69">
<p class="contentsEntryName"><span href="#/xhtml/chapter69#ch69" title="Link target outside of Sample">Late August</span></p></div>
<div class="contentsEntry" id="ch_70">
<p class="contentsEntryName"><span href="#/xhtml/chapter70#ch70" title="Link target outside of Sample">The Past</span></p></div>
<div class="contentsEntry" id="ch_71">
<p class="contentsEntryName"><span href="#/xhtml/chapter71#ch71" title="Link target outside of Sample">August 27 (Starlings)</span></p></div>
<div class="contentsEntry" id="ch_72">
<p class="contentsEntryName"><span href="#/xhtml/chapter72#ch72" title="Link target outside of Sample">End of August, Dawn</span></p></div>
<div class="contentsEntry" id="ch_73">
<p class="contentsEntryName"><span href="#/xhtml/chapter73#ch73" title="Link target outside of Sample">Sunset</span></p></div>
<div class="contentsEntry" id="pt_05">
<p class="contentsEntryNumber"><span href="#/xhtml/part05#pt05" title="Link target outside of Sample">Hurricane Notebook</span></p></div>
<div class="contentsEntry" id="ch_74">
<p class="contentsEntryName"><span href="#/xhtml/chapter74#ch74" title="Link target outside of Sample">September 2 (Misery)</span></p></div>
<div class="contentsEntry" id="ch_75">
<p class="contentsEntryName"><span href="#/xhtml/chapter75#ch75" title="Link target outside of Sample">Jacks</span></p></div>
<div class="contentsEntry" id="ch_76">
<p class="contentsEntryName"><span href="#/xhtml/chapter76#ch76" title="Link target outside of Sample">Humility</span></p></div>
<a id="page15"></a>
<div class="contentsEntry" id="ch_77">
<p class="contentsEntryName"><span href="#/xhtml/chapter77#ch77" title="Link target outside of Sample">September 10 (Money)</span></p></div>
<div class="contentsEntry" id="ch_78">
<p class="contentsEntryName"><span href="#/xhtml/chapter78#ch78" title="Link target outside of Sample">September 11</span></p></div>
<div class="contentsEntry" id="ch_79">
<p class="contentsEntryName"><span href="#/xhtml/chapter79#ch79" title="Link target outside of Sample">Order and Disorder</span></p></div>
<div class="contentsEntry" id="ch_80">
<p class="contentsEntryName"><span href="#/xhtml/chapter80#ch80" title="Link target outside of Sample">September 24 (Deconstruction)</span></p></div>
<div class="contentsEntry" id="ch_81">
<p class="contentsEntryName"><span href="#/xhtml/chapter81#ch81" title="Link target outside of Sample">Po Chü-i</span></p></div>
<div class="contentsEntry" id="pt_06">
<p class="contentsEntryNumber"><span href="#/xhtml/part06#pt06" title="Link target outside of Sample">Luxury Notebook</span></p></div>
<div class="contentsEntry" id="ch_82">
<p class="contentsEntryName"><span href="#/xhtml/chapter82#ch82" title="Link target outside of Sample">Luxury</span></p></div>
<div class="contentsEntry" id="ch_83">
<p class="contentsEntryName"><span href="#/xhtml/chapter83#ch83" title="Link target outside of Sample">Eclogue</span></p></div>
<div class="contentsEntry" id="ch_84">
<p class="contentsEntryName"><span href="#/xhtml/chapter84#ch84" title="Link target outside of Sample">October 7 (Sponges)</span></p></div>
<div class="contentsEntry" id="ch_85">
<p class="contentsEntryName"><span href="#/xhtml/chapter85#ch85" title="Link target outside of Sample">October 15 (Archimedes)</span></p></div>
<div class="contentsEntry" id="ch_86">
<p class="contentsEntryName"><span href="#/xhtml/chapter86#ch86" title="Link target outside of Sample">Hiroshige</span></p></div>
<div class="contentsEntry" id="ch_87">
<p class="contentsEntryName"><span href="#/xhtml/chapter87#ch87" title="Link target outside of Sample">The Leatherback</span></p></div>
<div class="contentsEntry" id="ch_88">
<p class="contentsEntryName"><span href="#/xhtml/chapter88#ch88" title="Link target outside of Sample">November 3 (The Spot)</span></p></div>
<div class="contentsEntry" id="ch_89">
<p class="contentsEntryName"><span href="#/xhtml/chapter89#ch89" title="Link target outside of Sample">The Toad</span></p></div>
<div class="contentsEntry" id="ch_90">
<p class="contentsEntryName"><span href="#/xhtml/chapter90#ch90" title="Link target outside of Sample">November 12 (Justice)</span></p></div>
<div class="contentsEntry" id="ch_91">
<p class="contentsEntryName"><span href="#/xhtml/chapter91#ch91" title="Link target outside of Sample">Storm Valediction</span></p></div>
<div class="contentsEntry" id="pt_07">
<p class="contentsEntryNumber"><span href="#/xhtml/part07#pt07" title="Link target outside of Sample">Astral Notebook</span></p></div>
<div class="contentsEntry" id="ch_92">
<p class="contentsEntryName"><span href="#/xhtml/chapter92#ch92" title="Link target outside of Sample">The Indivisibles</span></p></div>
<div class="contentsEntry" id="ch_93">
<p class="contentsEntryName"><span href="#/xhtml/chapter93#ch93" title="Link target outside of Sample">Middle Age</span></p></div>
<a id="page16"></a>
<div class="contentsEntry" id="ch_94">
<p class="contentsEntryName"><span href="#/xhtml/chapter94#ch94" title="Link target outside of Sample">Then</span></p></div>
<div class="contentsEntry" id="ch_95">
<p class="contentsEntryName"><span href="#/xhtml/chapter95#ch95" title="Link target outside of Sample">December 6 (Years)</span></p></div>
<div class="contentsEntry" id="ch_96">
<p class="contentsEntryName"><span href="#/xhtml/chapter96#ch96" title="Link target outside of Sample">The Work</span></p></div>
<div class="contentsEntry" id="ch_97">
<p class="contentsEntryName"><span href="#/xhtml/chapter97#ch97" title="Link target outside of Sample">The Future</span></p></div>
<div class="contentsEntry" id="ch_98">
<p class="contentsEntryName"><span href="#/xhtml/chapter98#ch98" title="Link target outside of Sample">Stars</span></p></div>
<div class="contentsEntry" id="ch_99">
<p class="contentsEntryName"><span href="#/xhtml/chapter99#ch99" title="Link target outside of Sample">December 30 (The World)</span></p></div>
<br/>
<div class="contentsEntry1" id="ack_01">
<p class="contentsEntryName1"><span href="#/xhtml/ack#ack01" title="Link target outside of Sample">Acknowledgments</span></p></div>
<div class="contentsEntry1" id="ata_01">
<p class="contentsEntryName1"><span href="#/xhtml/ata#ata01" title="Link target outside of Sample">About the Author</span></p></div>
<div class="contentsEntry1" id="adc_01">
<p class="contentsEntryName1"><span href="#/xhtml/acm#adc01" title="Link target outside of Sample">Other Books by Campbell McGrath</span></p></div>
<div class="contentsEntry1" id="cre_01">
<p class="contentsEntryName1"><span href="#/xhtml/credits#cre01" title="Link target outside of Sample">Credits</span></p></div>
<div class="contentsEntry1" id="cop_01">
<p class="contentsEntryName1"><span href="#/xhtml/copy#cop01" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName1"><span href="#/xhtml/atp#atp01" title="Link target outside of Sample">About the Publisher</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?914a803e